import PlanFragment from './PlanFragment';
export default `
	query ListPlans(
		$filter: ListPlansTableFilterInput
		$limit: Int
		$offset: Int
		$sortAttribute: String
		$sortDirection: String
	) {
		listPlans(
			filter: $filter
			limit: $limit
			offset: $offset
			sortAttribute: $sortAttribute
			sortDirection: $sortDirection
		) {
			size
			total
			items {
				...PlanFragment
			}
		}
	}
	${PlanFragment}
`;
